import { showOrCloseNotification } from "context/generalSlice";
import { AppDispatch } from "context/store";
export const dispatchNotification = (dispatch: AppDispatch, msg: string) => {
  //SHOW SUCCESS MESSAGE
  dispatch(
    showOrCloseNotification({
      show: true,
      message: msg,
    })
  );
  setTimeout(() => dispatch(showOrCloseNotification({ show: false })), 2500);
  return;
};
